import { useEffect } from 'react';
import { useFedStore } from '../store';
import { Ic } from '../icons';
import { Rv, Eyebrow } from '../ui';

import { useLegalDocuments } from '../../ui/LegalAcceptance';

function LegalLayout({ type, title, intro, sections, bundle }) {
  const { go } = useFedStore();
  useEffect(() => {
    document.title = `${title} — Федерация киберспорта СКО`;
    return () => { document.title = 'Федерация киберспорта СКО'; };
  }, [title]);

  return (
    <div className="fed-legal-page fed-pagewrap max-w-[1060px] mx-auto px-6">
      <Rv className="fed-legal-head">
        <Eyebrow>{type}</Eyebrow>
        <h1>{title}</h1>
        <p>{intro}</p>
        <div className="fed-legal-meta">
          <span><Ic name="calendar" size={15} />Редакция {bundle.version}</span>
          <span><Ic name="building" size={15} />Применимое право: Республика Казахстан</span>
        </div>
      </Rv>

      <div className="fed-legal-layout">
        <aside className="fed-legal-toc">
          <b>Содержание</b>
          {sections.map((section, index) => (
            <a key={section.title} href={`#legal-${index + 1}`}>{index + 1}. {section.title}</a>
          ))}
        </aside>

        <main className="fed-legal-content">
          {sections.map((section, index) => (
            <Rv as="section" key={section.title} id={`legal-${index + 1}`}>
              <span className="fed-legal-number">{String(index + 1).padStart(2, '0')}</span>
              <div>
                <h2>{section.title}</h2>
                {section.body.map((block, blockIndex) => {
                  if (Array.isArray(block)) return (
                    <ul key={blockIndex}>{block.map((item) => <li key={item}>{item}</li>)}</ul>
                  );
                  return <p key={blockIndex}>{block}</p>;
                })}
              </div>
            </Rv>
          ))}

          <div className="fed-legal-contact">
            <Ic name="phone" size={22} />
            <div>
              <h2>Контакты для юридически значимых обращений</h2>
              <p>{bundle.operator}, Республика Казахстан, Северо-Казахстанская область, г. Петропавловск.</p>
              <p>Телефон: <a href="tel:+77006780221">+7 700 678 0221</a> · Telegram: <a href="https://t.me/fc_sko" target="_blank" rel="noreferrer">@fc_sko</a> · <button onClick={() => go('contacts')}>форма обратной связи</button>.</p>
              <p>В обращении укажите Ф.И.О. или идентификатор аккаунта, суть требования и сведения, позволяющие подтвердить принадлежность аккаунта. Мы вправе запросить разумное подтверждение личности, не собирая избыточные данные.</p>
            </div>
          </div>

          <div className="fed-legal-links">
            <span>Официальные источники:</span>
            <a href="https://adilet.zan.kz/rus/docs/Z1300000094" target="_blank" rel="noreferrer">Закон РК «О персональных данных и их защите»</a>
            <a href="https://adilet.zan.kz/rus/docs/Z1500000418" target="_blank" rel="noreferrer">Закон РК «Об информатизации»</a>
            <a href="https://adilet.zan.kz/rus/docs/K2600000255" target="_blank" rel="noreferrer">Цифровой кодекс РК</a>
          </div>
        </main>
      </div>
    </div>
  );
}

function CurrentLegalDocument({ kind, type, title, intro }) {
  const { bundle, error, retry } = useLegalDocuments();
  if (error) return <div className="fed-pagewrap" role="alert">{error} <button onClick={retry}>Повторить</button></div>;
  if (!bundle) return <p className="fed-pagewrap" role="status">Загружаем документы…</p>;
  const document = bundle.documents.find((item) => item.kind === kind);
  return <LegalLayout type={type} title={title} intro={intro} sections={document.sections} bundle={bundle} />;
}

export function PrivacyPolicy() {
  return <CurrentLegalDocument kind="privacy" type="Защита данных" title="Политика конфиденциальности" intro="Правила обработки и защиты персональных данных пользователей cybersportleague.kz." />;
}

export function UserAgreement() {
  return <CurrentLegalDocument kind="terms" type="Правила платформы" title="Пользовательское соглашение" intro="Условия использования сайта, аккаунтов, команд и турнирных сервисов Федерации киберспорта СКО." />;
}
